<template>
<div id="content-wrap" class="content-wrapper">
  <div class="fade-header"></div>
  <section class="sl-content">
    <transition name="page" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</div>
</template>

<script>
export default {
  name: 'content-wrap'
}
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
}

.content-wrapper {
  margin-left: 0;
  background-color: #eff1f4;
}

.fade-header {
  width: 100%;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// ContentWrap.vue?c669698e